import React, { type FunctionComponent } from 'react';

export interface AddCommentIconProps {
  label: string;
  color: string;
}

const AddCommentIcon: FunctionComponent<AddCommentIconProps> = ({ label, color }) => {
  return (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={label}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.46875 1.5C2.00276 1.5 1.625 1.87776 1.625 2.34375V10.4682L3.53812 9.375H10.5312C10.9972 9.375 11.375 8.99724 11.375 8.53125V2.34375C11.375 1.87776 10.9972 1.5 10.5312 1.5H2.46875ZM0.5 2.34375C0.5 1.25644 1.38144 0.375 2.46875 0.375H10.5312C11.6186 0.375 12.5 1.25644 12.5 2.34375V8.53125C12.5 9.61856 11.6186 10.5 10.5312 10.5H3.83688L1.34158 11.9259C1.16748 12.0254 0.953593 12.0247 0.780166 11.924C0.606739 11.8234 0.5 11.638 0.5 11.4375V2.34375ZM5.93752 4.87518V3.18768H7.06252V4.87518H8.75002V6.00018H7.06252V7.68768H5.93752V6.00018H4.25002V4.87518H5.93752Z"
        fill={color}
      />
    </svg>
  );
};

export default AddCommentIcon;
